fx.ns("desktop.player", class BookPreviewArea extends shared.stage.BookArea {
    
    constructor(page, model, parentContainer, side, preview)
	{
        super(page, model, parentContainer, side, preview);
        this.parentWidth = 0;
        this.parentHeight = 0;
        this._index = 0;
    }

    create()
    {
        super.create();
        
        this.fullscreenButton = new fx.components.Button({label : fx.text("Cliquez ici pour agrandir"), className:"fullscreenButton"});
        this.leftArrow = new fx.components.IconButton({icon : fx.get("assets").previousIcon, iconRatio : 0.8, className:"leftArrow"});
        this.rightArrow = new fx.components.IconButton({icon : fx.get("assets").nextIcon, iconRatio : 0.8, className:"rightArrow"});
        this.leftEventBox = new fx.components.Box("left-event-box");
        this.rightEventBox = new fx.components.Box("right-event-box");

        if(fx.browser.isDesktop)
        {
		    this.addChild(this.fullscreenButton, {top :this.stage.realHeight/2, left : 0, width: "90%", height: "130px"});
            this.addChild(this.leftArrow, {top: (this.book.pageHeight-85)/2, width: "50px", height: "100px", right: this.book.pageWidth + (this.page && this.page.isCover ? this.book.sliceWidth : 0) + this.book.pageWidth});
            this.addChild(this.rightArrow, {top: (this.book.pageHeight-85)/2, left: this.backgroundRight.left+this.backgroundRight.realWidth});
        }
        else
        {
            this.addChild(this.leftEventBox, {width: "50%", height: "100%", left: 0});
            this.addChild(this.rightEventBox, {width: "50%", height: "100%", right: 0});
        }
    }

    onReady()
    {
        super.onReady();
        if(!window.fx.browser.isMobile){
            if (this.leftArrow)
                this.on("click", this.previous, this.leftArrow);   
            if (this.rightArrow)
                this.on("click", this.next, this.rightArrow); 
        }
        else{
            this.on("tap", this.previous, this.leftEventBox);   
            this.on("tap", this.next, this.rightEventBox); 
            this.on("swipe", this._onSwipe, this.leftEventBox);   
            this.on("swipe", this._onSwipe, this.rightEventBox); 
        }  
        if(this.fullscreenButton)
            this.on("click", this._onFullScreen, this.fullscreenButton);

        this.on("fullscreenchange", this._onFullScreenChange, window);
        this.on('mozfullscreenchange', this._onFullScreenChange, window);
        this.on('webkitfullscreenchange', this._onFullScreenChange, window);
        this.on('msfullscreenchange', this._onFullScreenChange, window);
    }

    _onSwipe(e){
        if (e.direction == "Left")
        {
            this.next();
        }
        else if (e.direction == "Right")
        {
            this.previous();
        }
    }

    setParentSize(width, height){
        this.parentWidth = width;
        this.parentHeight = height;
        this.updateDisplay();
    }

    // Display previous page when left arrow is clicked
    previous()
	{	
		if (this._index > 0)
		{
			this._index--;
			this.updatePage();
			this.trigger("previous");
		}
	}

    // Display next page when right arrow is clicked
	next()
	{
		if (this._index < this.book.pages.length)
		{
			this._index++;
			this.updatePage();
			this.trigger("next");
		}
	}

    // Get the page for the current index in the model , and refresh page display
    updatePage()
	{
		let page = (this._index == this.book.pages.length) ? this.book.cover : this.book.pages.getItemAt(this._index);
		this.displayedSide = page.isCover ? (this._index == 0 ? "right" : "left") : "";
		this.page = page;
		this.updateDisplay();
		if (page.isCover)
			this.activePart = "";
	}

    // refresh display (elements positions if album size have changed (single page => cover or double page ) )
    updateDisplay()
    {
        super.updateDisplay();
        let margin = 0, percentage = 0;
        if(!window.fx.browser.isMobile){
            margin = this.book.shape_option == "landscape" ? 60 : 50;	
            percentage = this.book.shape_option == "landscape" ? 0.95 : 0.9;
        }
        else{
            margin = 0;
            percentage = 1; //remove margins on mobile
        }
        
        let width = this.parentWidth;
        let height = this.parentHeight;
        let screenWidth = width* percentage;
        let screenHeight = Math.min(Math.max(0,height), height * percentage);
        let ratio = this.book.coverHeight/this.book.coverWidth;
        let scale = (screenWidth * ratio < screenHeight) ? (screenWidth / (this.book.coverWidth+margin)) : (screenHeight / this.book.coverHeight);
        let xPos = (width/scale - (this.realWidth )) / 2;
        let yPos = (height/scale - (this.book.coverHeight )) / 2;

        this.css({ "transform" : "scale(" + scale + ") translate(" + 0 + "px) translate(" + xPos + "px," + yPos + "px)" }); 
        
        if(this.fullscreenButton)
            this.fullscreenButton.css({ "transform" : "scale(" + 1/scale + ")"});

        if (this.displayedSide == "right")
        {      
            if(this.fullscreenButton)
                this.fullscreenButton.viewport({top :(this.stage.realHeight/2)-(this.fullscreenButton.realHeight/2), left : (this.book.pageWidth/2)-(this.fullscreenButton.realWidth/2)+5, width: "200px"});

            this.leftArrow.hide();
            this.rightArrow.show();
            this.leftEventBox.disable();
            this.rightEventBox.enable();
            this.rightEventBox.viewport({width: "100%", height: "100%", right: 0});
        }
        else if (this.displayedSide == "left")
        {
            if(this.fullscreenButton)
                this.fullscreenButton.viewport({top :(this.stage.realHeight/2)-(this.fullscreenButton.realHeight/2), left : (this.book.pageWidth/2)-(this.fullscreenButton.realWidth/2), width: "200px"});

            this.leftArrow.show();
            this.rightArrow.hide();
            this.rightEventBox.disable();
            this.leftEventBox.enable();
            this.leftEventBox.viewport({width: "100%", height: "100%", left: 0});
        }
        else
        {
            if(this.fullscreenButton)
                this.fullscreenButton.viewport({top :(this.stage.realHeight/2)-(this.fullscreenButton.realHeight/2), left : (this.stage.realWidth/2)-(this.fullscreenButton.realWidth/2), width: "200px"});

            this.leftArrow.show();
            this.rightArrow.show();
            this.leftEventBox.enable();
            this.rightEventBox.enable();  
            this.leftEventBox.viewport({width: "50%", height: "100%", left: 0});
            this.rightEventBox.viewport({width: "50%", height: "100%", right: 0});
        }

        if(!window.fx.browser.isMobile)
        {
            this.leftArrow.viewport({width: "43px", height: "85px",left: this.stage.x-this.leftArrow.realWidth});
            this.rightArrow.viewport({width: "43px", height: "85px",left: this.stage.x+this.stage.realWidth});
        }
    }

    // toggle fullscreen
    _onFullScreen(){
        this.trigger("fullscreen");
	}

    _onFullScreenChange(){
        if (document.webkitIsFullScreen === false)
        {
            // hack for safari
            this.container.css("overflow", "visible");
            this.removeClass("fullscreen");
        }
        else
        {
             // hack for safari
            this.container.css("overflow", "hidden");
            this.addClass("fullscreen");
        }
	}

});